<template>
    <div class="form-group">
      <select
        :value="value"
        :on="listeners"
        :bind="$attrs"
        @input="$emit('input', $event.target.value)"
        @blur="touchValidation"
        :class="classValidation()"
        required
      >
        <option
          v-if="placeholder"
          disabled selected value=""
        >{{ placeholder }}</option>

        <slot />
      </select>
    </div>
</template>

<script>
  import classValidationChecker from '@/utils/classValidationChecker'

  export default {
    props: {
      value: { type: String, required: true },
      validation: { type: Object, default: null },
      placeholder: { type: String, default: null }
    },
    
    computed: {
      listeners () {
        // eslint-disable-next-line no-unused-vars
        const { input, ...listeners } = this.$listeners
        return listeners
      },
    },

    methods: {
      touchValidation () {
        if (this.validation) {
          this.validation.$touch()
        }
      },

      classValidation () {
        if (this.validation) {
          return classValidationChecker(this.validation)
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  select {
    color: #000;
    font-size: 16px;
    background-color: #fff;
    height: 47px;

  &:invalid { color: rgba(0, 0, 0, .4) }

    option:not([disabled]) { color: #000 }

    
  }
</style>